import { render, staticRenderFns } from "./articleModule.vue?vue&type=template&id=078aefcd&scoped=true&"
import script from "./articleModule.vue?vue&type=script&lang=js&"
export * from "./articleModule.vue?vue&type=script&lang=js&"
import style0 from "./articleModule.vue?vue&type=style&index=0&id=078aefcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078aefcd",
  null
  
)

export default component.exports